export default __webpack_public_path__ + "static/en-c930fc4915b3ee35fba4f85ce0a8e04e.svg";